import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TableActions } from '../../components';
import { Button, Col, Row, message } from 'antd';
import { fuelsUsedHistoryFormFields } from '../../constants/formsAddEquipment';
import { downloadFileByGetURL, downloadFileByPostURL } from '../../utils/files';
import { FORMAT_DEFAULT_DATE, links } from '../../utils';
import { MonthYearField } from '../../atoms';
import { productionUnitFuelsHistoryExists } from '../../actions/actionHelpers/endpoints';
import dayjs from '../../utils/dayjs';

import { Form } from 'react-final-form';
import RffFields from '../../atoms/rff/RffFields';

class FuelsUsedHistory extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    productionUnitId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isHydrogenContext: PropTypes.bool,
  };

  handleExportFuelsUsedHistory = async (values) => {
    const { t, isHydrogenContext, productionUnitId } = this.props;
    const month = values?.[fuelsUsedHistoryFormFields.MONTH];
    const year = values?.[fuelsUsedHistoryFormFields.YEAR];

    if (!month || !year) {
      message.error(t('fuelsUsed.history.monthNotEnteredError'));
      return;
    }

    if (!isHydrogenContext) {
      const params = {
        productionUnitId,
        historyDate: dayjs()
          .month(month - 1)
          .year(year)
          .format(FORMAT_DEFAULT_DATE),
      };
      const response = await productionUnitFuelsHistoryExists(params);
      if (response.data > 0) {
        downloadFileByPostURL(
          links.productionUnitFuelsUsedHistoryCsv,
          params,
          'biofuel-data.xls'
        );
      } else {
        message.error(t('fuelsUsed.history.monthNoDataError'));
      }
    } else {
      const params = { productionUnitId, month, year };
      downloadFileByGetURL(
        links.hydrogenFuelExport,
        params,
        'fuel-data.xls',
        'get',
        t
      );
    }
  };

  render() {
    const { t } = this.props;

    return (
      <Form
        onSubmit={() => {}}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <TableActions>
              <Row style={{ lineHeight: '40px' }} gutter={24}>
                <Col span={12}>
                  <h3>{t('fuelsUsed.history.title')}:</h3>
                </Col>
                <Col span={5}>
                  <RffFields
                    names={[
                      fuelsUsedHistoryFormFields.MONTH,
                      fuelsUsedHistoryFormFields.YEAR,
                    ]}
                    className="date-field"
                    disabledDate={(current) =>
                      current.isAfter(dayjs().subtract(1, 'month'))
                    }
                    defaultPickerValue={dayjs().subtract(1, 'month')}
                    component={MonthYearField}
                    hasFeedback={false}
                  />
                </Col>
                <Col span={5}>
                  <Button
                    onClick={() => this.handleExportFuelsUsedHistory(values)}
                  >
                    {t('fuelsUsed.history.exportCsvBtn')}
                  </Button>
                </Col>
              </Row>
            </TableActions>
          </form>
        )}
      />
    );
  }
}

export default FuelsUsedHistory;
